import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../contexts/SettingsContext';

const LandingPage: React.FC = () => {
  const { isDarkMode } = useSettings();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            ChordRacer
          </h1>
          <p className="text-xl mb-8 text-gray-600 dark:text-gray-300">
            Train your hands to play any chord — instantly.
          </p>
          <Link
            to="/practice"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors duration-200"
          >
            Start Practicing
          </Link>
        </div>

        {/* Features Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className={`p-6 rounded-lg ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
            <div className="text-3xl mb-4">🎹</div>
            <h3 className="text-xl font-semibold mb-2">Any Voicing Allowed</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Practice with inversions, shell voicings, rootless — the way real pianists do.
            </p>
          </div>
          
          <div className={`p-6 rounded-lg ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
            <div className="text-3xl mb-4">📚</div>
            <h3 className="text-xl font-semibold mb-2">Real Music Progressions</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Chords are based on actual songs — not random exercises.
            </p>
          </div>
          
          <div className={`p-6 rounded-lg ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
            <div className="text-3xl mb-4">🎮</div>
            <h3 className="text-xl font-semibold mb-2">Level Up as You Improve</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Unlock new chords and track your mastery through a gamified system.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LandingPage;
